import { AxiosResponse } from 'axios'
import { ServiceDependencies } from 'lib/core/services/magento'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import { axiosClient } from 'lib/core/services/magento/client'

export interface GetCategoryListQueryObject {
  getCategoryList: {
    items: {
      id: boolean
      name: boolean
      children: boolean
      created_at: boolean
      include_in_menu: boolean
      is_active: boolean
      parent_id: boolean
      path: boolean
      pwa_layout: boolean
      level: boolean
      position: boolean
      updated_at: boolean
      custom_attributes: {
        attribute_code: boolean
        value: boolean
      }
    }
  }
}

export const getCategoryListQueryObject: GetCategoryListQueryObject = {
  getCategoryList: {
    items: {
      id: true,
      name: true,
      children: true,
      created_at: true,
      include_in_menu: true,
      is_active: true,
      parent_id: true,
      path: true,
      pwa_layout: true,
      level: true,
      position: true,
      updated_at: true,
      custom_attributes: {
        attribute_code: true,
        value: true
      }
    }
  }
}

export type GetCategoryListQuery = () => Promise<AxiosResponse<any>>

export const createGetCategoryListQuery = ({ getQueries }: ServiceDependencies): GetCategoryListQuery => async () => {
  const query = getQueries().getCategoryListQuery

  return axiosClient(jsonToGraphQLQuery(query), true)
}
